// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormUploadDocumentRequestModel from '../../model/dynamic-form-upload-document-request-model';
import DynamicFormUploadDocumentRequestDTO from '../dto/dynamic-form-upload-document-request-dto';
import dtoSchema from '../schemas/dynamic-form-upload-document-request-schema';

export default abstract class DynamicFormUploadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DynamicFormUploadDocumentRequestDTO>) {
    super();
    if (data) {
      this.uploadFile = data.uploadFile;
    }
  }
  /**
  * @type {binary}
  */
  uploadFile?: File;

  static toModel(dto: DeepPartial<DynamicFormUploadDocumentRequestDTO>): DynamicFormUploadDocumentRequestModel;
  static toModel(dto: DeepPartial<DynamicFormUploadDocumentRequestDTO> | undefined | null): DynamicFormUploadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<DynamicFormUploadDocumentRequestDTO> | undefined | null): DynamicFormUploadDocumentRequestModel | undefined {
    return dto ? new DynamicFormUploadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DynamicFormUploadDocumentRequestModel> | DynamicFormUploadDocumentRequestModel): DynamicFormUploadDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      uploadFile: unwrapped.uploadFile,
    } as DynamicFormUploadDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DynamicFormUploadDocumentRequestModel, can not map to DynamicFormUploadDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
